import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@service/auth.service';

@Component({
    selector: 'app-verify',
    templateUrl: './verify.component.html',
    styleUrls: [],
    standalone: false,
})
export class VerifyComponent {
    constructor(
        private authService: AuthService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    async ngOnInit() {
        if (!this.activatedRoute.snapshot.routeConfig?.path) {
            await this.router.navigate(['/home']);
        } else {
            this.authService.setLogInned(true);
            await this.router.navigate(['/home']);
        }
    }
}
